/**
 * Created by PRIME AI.
 * @author Samuel Hinchliffe <samuel@primeai.co.uk, sam.hinchliffe.work@gmail.com>
 * @see    [Linkedin] {@link https://www.linkedin.com/in/samuel-hinchliffe-2bb5801a5/}
 *
 * @summary This is widget works. A great framework for building out PRIME AI
 * Apps.
 *
 * Created at: 16/11/2023
 * @see       [PRIME-AI GITHUB] {@link https://github.com/PRIME-AI-GITHUB}
 * @see       [Website]         {@link https://www.primeai.co.uk/}
 * @copyright 2018-2023 PRIME AI LTD
*/

import AppFactory from './src/AppFactory';
import Component from './src/Component';
import App from './src/App';
import Analytics from './mixins/Analytics';
import Log from './mixins/Log';
import Modal from './mixins/Modal';
import PrimeAppManager from './src/PrimeAppManager';
import AppNotAllowedError from './mixins/AppNotAllowedError';
import CacheStorage from './mixins/CacheStorage';

export {
    AppFactory,
    App,
    Analytics,
    Component,
    Log,
    Modal,
    PrimeAppManager,
    AppNotAllowedError,
    CacheStorage,
};
